import { render, staticRenderFns } from "./mobile.vue?vue&type=template&id=51eebeaf&"
import script from "./mobile.vue?vue&type=script&lang=ts&"
export * from "./mobile.vue?vue&type=script&lang=ts&"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports